"use client";

import { useEffect, useState } from "react";
import { usePrefersReducedMotion } from "./usePrefersReducedMotion";

const easeOutCubic = (t: number) => 1 - (1 - t) ** 3;

export function useCountUp(
  target: number,
  { duration = 1900, start = 0 }: { duration?: number; start?: number } = {},
): number {
  const reduced = usePrefersReducedMotion();
  const [value, setValue] = useState(start);

  useEffect(() => {
    if (reduced) {
      setValue(target);
      return;
    }

    let frame = 0;
    let startedAt: number | null = null;

    const tick = (now: number) => {
      if (startedAt === null) startedAt = now;
      const progress = Math.min((now - startedAt) / duration, 1);
      setValue(Math.round(start + (target - start) * easeOutCubic(progress)));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target, duration, start, reduced]);

  return reduced ? target : value;
}
